// Imports
import { createGlobalStyle } from 'styled-components/macro';
import { GeneratedThemeProps } from './template-style';


// Global styles
const PaperStyle = createGlobalStyle<{ theme: GeneratedThemeProps }>`
	#root, #storybook-root {
		min-height: 100vh;
		font-family: ${(props) => props.theme.fontFamily};
		-webkit-font-smoothing: auto;
		color: ${(props) => props.theme.baseColor};
		background: #fff;
	}
`;

export default PaperStyle;
